export const IPS_AQUA = '#1FBFE5'

export const IPS_METRO_BLUE = '#179BC4'

export const DARK_BLUE = '#0094C9'

// $midnight-2 from scss/colors/_constants.scss — the design-system active toggle
// color (ToggleButton/ToggleGroup). Meets WCAG AA (4.9:1) with white text.
export const MIDNIGHT_2 = '#5A738F'

export const IPS_YELLOW = '#FFD540'

export const IPS_GRAY = '#A6AAAD'

// neutral-grey/neutral-grey-50 from Figma — the app top bar background.
export const NEUTRAL_GREY_50 = '#EBECED'

export const IPS_ORANGE = '#FC9930'

export const MIDDLE_GREEN = '#4BE7CC'

export const DARK_GREEN = '#229B96'

// Dark teal — a categorical color in chart/data palettes (not a brand UI color)
export const DARK_TEAL = '#006365'

export const TILE_BACKGROUND_GRADIENT =
  'linear-gradient(135deg, #E7F3F6 0%, rgba(195, 234, 242, 0.6) 100%)'

// secondary/green-800 — the tile's title and value share it.
export const TILE_TEXT = '#0C556C'

// The rule under the tile's value. The tile itself has no border.
export const TILE_DIVIDER = 'rgba(12, 85, 108, 0.2)'

export const TILE_RADIUS_PX = 16

// neutral-white/neutral-white-500 — the flat surface a chart card sits on. Unlike
// the metric tiles it has no gradient and no border, only the shared radius.
export const CHART_CARD_BACKGROUND = '#F8F9FA'

// neutral-grey/neutral-grey-500 from Figma — the chart card header title.
export const NEUTRAL_GREY_500 = '#394047'

// The chart card title, per Figma: 20px bold on a flat 100% line height, which
// is what lets it sit on the same baseline as the dropdowns beside it.
export const CHART_TITLE_FONT_SIZE = '20px'

export const CHART_TITLE_LINE_HEIGHT = 1

export const TILE_TITLE_FONT_SIZE = '15px'

export const TILE_TITLE_LINE_HEIGHT = 1.2

export const TILE_VALUE_FONT_SIZE = '28px'

export const NAV_BACKGROUND = '#0b6c93'

export const NAV_DIVIDER = 'rgba(255, 255, 255, 0.2)'

// Nav icons are white on the blue drawer; the active item inverts to
// dark-on-light because it sits on a near-white pill.
export const NAV_ICON = '#fff'

// $midnight-0 from scss/colors/_constants.scss — the body text color, used here
// for the active nav item, which sits on a near-white pill.
export const NAV_ACTIVE_FOREGROUND = '#182f46'

// Active nav item: a near-white pill fading to a translucent white on the right.
export const NAV_ACTIVE_PILL_GRADIENT =
  'linear-gradient(90deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.55) 100%)'

export const NAV_ITEM_RADIUS_PX = 10

// The drawer's right edge is rounded where it meets the page content.
export const NAV_DRAWER_RADIUS_PX = 24

export const DRAWER_WIDTH_OPEN_PX = 284

export const DRAWER_WIDTH_CLOSED_PX = 88

// Width of the panel that holds a nav group's sub-pages. It floats over the page
// beside the drawer, so it does not change the page width.
export const NAV_FLYOUT_WIDTH_PX = 260

// Width of the icon pill in the collapsed rail.
export const NAV_RAIL_ITEM_WIDTH_PX = 48

export const NAV_HOVER_BG = 'rgba(255, 255, 255, 0.08)'

export const NAV_DISABLED_TEXT = 'rgba(255, 255, 255, 0.5)'

// 4.7:1 on NAV_BACKGROUND. WCAG AA asks for 4.5:1, and 0.7 gave only 3.7:1.
export const NAV_INPUT_LABEL = 'rgba(255, 255, 255, 0.85)'

export const NAV_INPUT_BORDER = 'rgba(255, 255, 255, 0.4)'

export const APP_BAR_HEIGHT = '64px'

// The rounded-square icon tiles in the top bar (filter, create, download, apps).
export const HEADER_BUTTON_RADIUS_PX = 10

/**
 * The ceiling on a top-bar filter chip, and on the name heading of a map popup or
 * chart tooltip. Filter values are user data: a shape name can be a 100+ character
 * comma-separated list inside a *single* name, which stretches the chip across the
 * whole bar and grows the tooltip past the viewport.
 *
 * 320px clears the longest value the app ships today - the compare-dates chip
 * (`Compare Dates: Jan 1, 2026 - Mar 17, 2026`, about 300px with its delete icon).
 */
export const HEADER_CHIP_MAX_WIDTH_PX = 320
export const NAME_HEADING_MAX_WIDTH_PX = 320

export const INPUT_RADIUS_PX = 10

// The outline of a field sitting on its own white fill. MUI's default `divider`
// (rgba(0, 0, 0, 0.12)) reads as muddy grey once the field is no longer transparent.
export const INPUT_BORDER = '#D5D8DA'
